import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "calc(100vh - 120px)",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "5px",
    paddingRight: "5px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#000",
    marginBottom: "0px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  projectDetailsContainer: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingTop: "0px",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  projectDetailsTableWrapper: {
    padding: "15px",
    display: "inline-block",
  },
  projectDetailsTable: {
    "& .MuiTableCell-root": {
      border: "none",
      padding: "10px 16px",
      textAlign: "center",
    },
  },
  projectDetailsHeader: {
    fontSize: "0.875rem",
    color: "#000",
    fontWeight: 600,
    backgroundColor: "#E5F2F7",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  projectDetailsValue: {
    fontSize: "0.875rem",
    color: "#000",
    fontWeight: 400,
    backgroundColor: "#E5F2F7",
    textAlign: "center",
  },
  filterSection: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    flexWrap: "wrap",
    gap: "10px",
  },
  filterLeft: {
    display: "flex",
    alignItems: "flex-end",
    gap: "0.5rem",
    flexWrap: "wrap",
    flex: 1,
    minWidth: 0,
  },
  filterGroup: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    flexDirection: "column",
    marginTop: "10px",
  },
  filterLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
  },
  stylebutton: {
    borderRadius: "2rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    height: "32px",
    padding: "6px 12px",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#fff",
      textTransform: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: "#ec6535",
      color: "#fff",
      opacity: 0.5,
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
  filterRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "8px",
    flexShrink: 0,
    minWidth: "200px",
  },
  saveFilterButton: {
    borderRadius: "2rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    height: "32px",
    padding: "6px 12px",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#fff",
      textTransform: "none",
    },
  },
  searchButton: {
    borderRadius: "2rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    height: "32px",
    padding: "6px 24px",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#fff",
    },
  },
  refreshContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  lastSyncedText: {
    color: "#666",
  },
  refreshText: {
    cursor: "pointer",
    textDecoration: "underline",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  table: {
    width: "100%",
    tableLayout: "fixed",
  },
  headerCell: {
    fontWeight: "bold",
    padding: "12px 10px",
    backgroundColor: "#FFE5D9",
    borderBottom: "2px solid #C6C6C6",
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  tableCell: {
    padding: "12px 10px",
    borderBottom: "1px solid #C6C6C6",
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  dateTimeCell: {
    width: "140px",
    minWidth: "140px",
    maxWidth: "140px",
  },
  eventDescriptionCell: {
    width: "250px",
    minWidth: "250px",
    maxWidth: "250px",
  },
  statusCell: {
    width: "130px",
    minWidth: "130px",
    maxWidth: "130px",
  },
  organizationCell: {
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
  },
  roleCell: {
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
  },
  usernameCell: {
    width: "180px",
    minWidth: "180px",
    maxWidth: "180px",
  },
  statusChip: {
    fontWeight: 500,
    color: "white",
    fontSize: "0.75rem",
    height: "auto",
    minHeight: "24px",
    borderRadius: "4px",
    width: "120px",
    display: "inline-flex",
    "& .MuiChip-label": {
      padding: "4px 4px",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "normal",
      wordWrap: "break-word",
      textAlign: "center",
    },
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
    paddingBottom: "10px",
    marginBottom: "0px",
    flexShrink: 0,
    "& .MuiGrid-container": {
      paddingBottom: "0px",
      marginBottom: "0px",
    },
  },
  tableContainer: {
    marginTop: 24,
    marginBottom: 10,
    boxShadow: 'none',
    border: '1px solid #C6C6C6',
    width: '100%',
    overflowX: 'auto',
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    [theme.breakpoints.up('xl')]: {
      maxHeight: 'calc(100vh - 420px)',
    },
    [theme.breakpoints.down('xl')]: {
      maxHeight: 'calc(100vh - 370px)',
    },
    [theme.breakpoints.down('lg')]: {
      maxHeight: 'calc(100vh - 320px)',
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: 'calc(100vh - 270px)',
    },
  },
  refreshContainerSty: {
    display: "flex",
    justifyContent: "flex-end",
  },
  padR20: {
    paddingRight: 20,
  },
  refreshSty: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: "8px",
  },
  formPerPage: {
    minWidth: 60,
    fontSize: "0.875rem",
    "& .MuiOutlinedInput-root": {
      outline: "none !important",
      "&.Mui-focused": {
        outline: "none !important",
        "& fieldset": {
          borderWidth: "1px !important",
        },
      },
    },
  },
  outlined: {
    padding: "8px",
  },
  searchSelect: {
    "& .MuiOutlinedInput-root": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: "4px",
      borderBottomLeftRadius: "4px",
      outline: "none !important",
      "& fieldset": {
        borderRight: "1px solid #000 !important",
        borderColor: "#000 !important",
        borderWidth: "1px !important",
        borderTop: "1px solid #000 !important",
        borderBottom: "1px solid #000 !important",
        borderLeft: "1px solid #000 !important",
      },
      "&:hover fieldset": {
        borderRight: "1px solid #000 !important",
        borderColor: "#000 !important",
        borderWidth: "1px !important",
      },
      "&.Mui-focused": {
        outline: "none !important",
        "& fieldset": {
          borderRight: "1px solid #000 !important",
          borderColor: "#000 !important",
          borderWidth: "1px !important",
          borderTop: "1px solid #000 !important",
          borderBottom: "1px solid #000 !important",
          borderLeft: "1px solid #000 !important",
        },
      },
    },
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      outline: "none !important",
      "& fieldset": {
        borderLeft: "none",
        borderColor: "#000 !important",
        borderWidth: "1px !important",
        borderTop: "1px solid #000 !important",
        borderBottom: "1px solid #000 !important",
        borderRight: "1px solid #000 !important",
      },
      "&:hover fieldset": {
        borderLeft: "none",
        borderColor: "#000 !important",
        borderWidth: "1px !important",
      },
      "&.Mui-focused": {
        outline: "none !important",
        "& fieldset": {
          borderLeft: "none",
          borderColor: "#000 !important",
          borderWidth: "1px !important",
          borderTop: "1px solid #000 !important",
          borderBottom: "1px solid #000 !important",
          borderRight: "1px solid #000 !important",
        },
      },
    },
  },
}));

